import React from "react";
import {formatDateString} from "../../utils/daysOptions";
import {Skeleton} from "../../components/general/Skeleton";
import {useTranslation} from "react-i18next";
// import * as IconFontAwesome from "react-icons/fa6";

function getValue(text: string | number | Date | undefined | null | React.ReactNode) {
    if (text === undefined || text === null || text === 'null' || text === 'undefined') {
        return '-'
    }
    if (text instanceof Date) {
        return formatDateString(text)
    } else if (text) {
        return text
    }
}

interface ItemStatusTextProps {
    value?: string;
}
export function ItemStatusText({value}: ItemStatusTextProps) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    function getStatusColor(value: string | undefined) {
        switch (value) {
            case 'CESANTE':
                return 'bg-yellow-300'
            case 'JUBILADO':
                return 'bg-blue-500'
            default:
                return 'bg-success'
        }
    }

    function getText(value: string | undefined) {
        switch (value) {
            case 'CESANTE':
                return t('cesante')
            case 'JUBILADO':
                return t('retired')
            default:
                return t('active')
        }
    }
    
    return(
        <div className={'flex flex-row bg-white pr-1 gap-1 rounded-[4px] items-center max-h-[30px]'}>
            <div
                className={`rounded-l-[10px] min-w-[6px] max-w-[6px] min-h-full h-[30px] ${getStatusColor(value)}`}/>
            <span className={`text-[18px] font-light`}>{getText(value)}</span>
        </div>
    )
}

export function getColor(value: string | undefined) {
    if (!value) {
        return 'bg-gray-200'
    }
    if (value.includes('A')) {
        return 'bg-green-200'
    }
    if (value.includes('B') || value.includes('C')) {
        return 'bg-yellow-200'
    }
    if (value.includes('T')) {
        return 'bg-orange-300'
    }
    return 'bg-gray-100'
}

interface QualificationProps {
    label: string;
    value?: string;
}
export function Qualification({label, value}: QualificationProps) {
    return(
        <div className={'flex flex-col items-center'}>
            {/*<span className={'font-bold text-empColorPrimary'}>{label}</span>*/}
            <div className={`flex items-center mt-1 justify-center rounded-full w-[40px] h-[40px] font-bold ${getColor(value)}`}>{value ? value : '-'}</div>
        </div>
    )
}

interface ItemNumberProps {
    label: string;
    value?: string | number;
    className?: string;
    loading?: boolean;
}
export function ItemNumber({label, value, className, loading}: ItemNumberProps) {
    return(
        <div className={`${className} grid grid-cols-2 bg-gray-200 rounded-[4px] items-center`}>
            <div className={'rounded-[4px] text-[13px] h-full flex px-2 py-1 items-center bg-header font-bold text-white'}>{`${label}:`}</div>
            {
                loading ? <Skeleton/> :
                <div className={`font-sans px-2`}>{value}</div>
            }
        </div>
    )
}

interface PropsItemHeader {
    text?: string,
    loading?: boolean,
    icon?: React.ReactNode
}
export function ItemHeader({text, loading, icon}: PropsItemHeader) {
    return (
        <>
            {loading ?
                <div className={'min-w-[100px]'}>
                    <Skeleton/>
                </div> :
                <div className={'gap-1 flex flex-row items-center'}>
                    {icon}{text ? text : '-'}
                </div>
            }
        </>
    )
}

interface ItemInfoProps {
    label: string;
    text?: string | number | Date | null;
    icon?: React.ReactNode;
    className?: string;
    classNameValue?: string;
    loading?: boolean;
}

export function ItemInfo({label, text, icon, className, loading, classNameValue}: ItemInfoProps) {
    return (
        <div className={`${className} flex flex-col gap-[3px]`}>
            <span className={'font-bold text-empColorPrimary'}>{label}</span>
            <div className={'flex flex-row justify-start items-center gap-1'}>{icon}
                {
                    loading ? <Skeleton className={'min-h-[20px] w-full min-w-[20px]'}/> :
                    <span className={`${classNameValue ? classNameValue : 'text-[16px]'} font-light`}>{getValue(text)}</span>
                }
            </div>
        </div>
    )
}

interface ItemInfoSpouseProps {
    label: string;
    text?: string | number | Date | null | React.ReactNode;
    icon?: React.ReactNode;
    classNameContent?: string;
    className?: string;
    loading?: boolean;
}
export function ItemInfoSpouse({label, text, icon, className, classNameContent, loading}: ItemInfoSpouseProps) {
    return (
        <div className={`${classNameContent} flex flex-col gap-[3px]`}>
            <span className={'font-semibold text-labelColor'}>{label}</span>
            <div className={'flex flex-row items-center gap-1'}>{icon}
                {
                    loading ? <Skeleton/> :
                    <span className={`font-light ${className ? className : 'text-[16px]'}`}>{getValue(text)}</span>
                }
            </div>
        </div>
    )
}
